module.exports = __webpack_public_path__ + "img/check.8173f286.svg";